import React from 'react';
import { EyeInvisibleOutlined } from '@ant-design/icons';

export const EyeShut = (props) => (
    <EyeInvisibleOutlined style={{ fontSize: '18px', marginRight: '5px', marginTop: '2px' }} {...props} />
);
